import { mapActions, mapGetters } from 'vuex'
import MainButton from '@/components/MainButton/index'
import ResponseDialog from '@/components/ResponseDialog/index'

export default {
  name: 'settings-change-password',
  components: {
    MainButton,
    ResponseDialog
  },
  data: () => ({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    loading: false,
    changePasswordDialog: false,
    dialogText: '',
    changePasswordForm: false,
    passwordRules: [
      v => !!v || 'Required',
      v => (v && v.length >= 8) || 'Password must be at least 8 characters'
    ]
  }),
  computed: {
    ...mapGetters('profile', {
      changePasswordResponse: 'CHANGE_PASSWORD_RESPONSE'
    }),
    ...mapGetters('auth', {
      userObject: 'USER_OBJ'
    })
  },
  methods: {
    ...mapActions('profile', {
      changePasswordAction: 'CHANGE_PASSWORD'
    }),
    cancel() {
      this.$router.push('/settings')
    },
    save() {
      if (this.$refs.changePasswordForm.validate()) {
        this.loading = true

        const payload = {
          id: this.userObject.id,
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
          confirmNewPassword: this.confirmNewPassword
        }

        this.changePasswordAction(payload).then(() => {
          const { message } = this.changePasswordResponse

          this.loading = false
          this.dialogText = message
          this.changePasswordDialog = true
        })
      }
    },
    dialogButtonClick() {
      this.changePasswordDialog = false
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
      this.$refs.changePasswordForm.reset()

      if (this.changePasswordResponse.success) {
        this.$router.push({ name: 'settings' })
      }
    }
  },
  activated() {
    this.$store.commit('SET_IMAGE_BACKGROUND', true)
    this.$store.commit('SET_SHOW_BOTTOM_NAV', false)
    this.$store.commit('SET_PAGE_TITLE', 'change password')
  },
  deactivated() {
    this.$store.commit('SET_IMAGE_BACKGROUND', false)
    this.$store.commit('SET_SHOW_BOTTOM_NAV', true)
  }
}
